var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8449 5.11014C28.0128 1.54788 23.0472 -0.287225 17.8117 0.0366165C8.25839 0.6843 0.540159 8.61843 0.162343 18.1178C0.10837 19.737 0.594133 23.0834 0.917975 24.6486L1.24182 24.0009C1.83553 22.8135 2.59116 21.734 3.56268 20.8165L13.4938 11.1552C13.6018 11.0472 13.6558 10.9933 13.7637 10.8853C14.9511 9.80585 16.4084 9.05022 18.2435 8.94227C20.9962 8.78035 23.6409 9.6979 25.6379 11.587C27.6349 13.4761 28.7684 16.0668 28.7684 18.8194C28.7684 19.5211 28.4445 20.2767 27.8508 20.8704L11.9826 36.4149C13.9796 38.3039 16.6785 39.3287 19.4311 39.1667C24.0189 38.8969 27.0962 34.4703 29.956 31.6104L34.2739 27.2925C34.9216 26.6449 35.4073 25.8892 35.8931 25.1336C37.0805 23.2445 37.728 21.0863 37.728 18.8194C37.728 13.638 35.5691 8.6724 31.8449 5.11014Z",
    fill: "#182740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.81 23.351L35.8925 25.1322C35.3527 25.9416 34.813 26.4813 34.1653 27.2372L24.612 36.7905C24.1802 37.1683 23.7484 37.4921 23.4785 37.708C22.3451 38.5176 20.9958 39.0034 19.4845 39.1114C16.7318 39.2733 14.0871 38.3557 12.0901 36.4666C10.0931 34.5776 8.95963 31.9868 8.95963 29.2342C8.95963 28.5325 9.28347 27.7769 9.87718 27.1832L25.7994 11.6388C23.8024 9.74969 21.1037 8.77638 18.351 8.9383C16.5159 9.04625 14.9507 9.74948 13.7633 10.829L13.4934 11.0988L3.61624 20.7603C2.64471 21.6779 1.88908 22.8113 1.29537 23.9448C0.485763 25.6179 0 27.3991 0 29.1802C0 34.3617 2.15895 39.3273 5.9371 42.8895C9.76923 46.4518 14.7348 48.2869 19.9703 47.963C29.4696 47.3693 37.1878 39.4352 37.5657 29.8819C37.6196 28.3166 37.1339 24.8623 36.81 23.351Z",
    fill: "url(#paint0_linear_172_6885)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_6885",
    x1: 18.7837,
    y1: 8.90481,
    x2: 18.7837,
    y2: 47.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F2A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    stopColor: "#203DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5654,
    stopColor: "#095AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7312,
    stopColor: "#0065FC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/LogoBlack.2d0188c7add221145946d65ac8584668.svg";
export { ForwardRef as ReactComponent };